import { formatDate} from "@/Modules/utils/dateFormatter";
import { mapDateToObject } from "./GlobalMapper";

export function mapJobsToDisplay(array) {
  return array.map((item) => ({
    Process: item.releaseName,
    Tenant: item.tenantName,
    "Run type": item.type,
    Host: item.hostMachineName,
    "Raw massage": item.info,
    Status: item.state,
    Priority: item.jobPriority,
    Source: item.source,
    Start: mapDateToObject(item.startTime),
    End: mapDateToObject(item.endTime),
    VersionId: item.releaseVersionId,
    Nummer: item.id,
    Jobkey: item.key,
    organizationUnitId: item.organizationUnitId,
    InputValues: item.inputArguments,
    HasRecording: item.hasMediaRecorded,
  }));
}

export function mapJobLog(array) {
  return array.map((item) => ({
    Time: formatDate(item.timeStamp),
    level: item.level,
    message: formatMessage(item.message),
  }));
}